module.exports = __webpack_public_path__ + "static/media/b-sci-major-23_LR.52aeebd9.jpg";